/**
 * Modern Animations & Interactions for Plantenwelt
 */

(function () {
    'use strict';

    // Intersection Observer für Scroll-Animationen
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const fadeInObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                fadeInObserver.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Elemente für Fade-In Animation beobachten
    document.addEventListener('DOMContentLoaded', () => {
        const fadeElements = document.querySelectorAll('.product-card-modern, .trust-badges-modern__item');
        fadeElements.forEach(el => {
            el.style.opacity = '0';
            el.style.transform = 'translateY(20px)';
            el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
            fadeInObserver.observe(el);
        });
    });

    // Wishlist Funktionalität
    class WishlistManager {
        constructor() {
            this.storageKey = 'plantenwelt_wishlist';
            this.wishlist = this.loadWishlist();
            this.init();
        }

        init() {
            document.addEventListener('click', (e) => {
                const wishlistBtn = e.target.closest('.product-card-modern__wishlist');
                if (wishlistBtn) {
                    e.preventDefault();
                    const productId = wishlistBtn.dataset.productId;
                    this.toggleWishlist(productId, wishlistBtn);
                }
            });

            // Update UI beim Laden
            this.updateAllButtons();
        }

        loadWishlist() {
            try {
                const stored = localStorage.getItem(this.storageKey);
                return stored ? JSON.parse(stored) : [];
            } catch (e) {
                return [];
            }
        }

        saveWishlist() {
            try {
                localStorage.setItem(this.storageKey, JSON.stringify(this.wishlist));
            } catch (e) {
                console.error('Could not save wishlist:', e);
            }
        }

        toggleWishlist(productId, button) {
            const index = this.wishlist.indexOf(productId);

            if (index > -1) {
                // Remove from wishlist
                this.wishlist.splice(index, 1);
                button.classList.remove('is-active');
                this.showNotification('Aus Wunschliste entfernt');
            } else {
                // Add to wishlist
                this.wishlist.push(productId);
                button.classList.add('is-active');
                this.showNotification('Zur Wunschliste hinzugefügt');
            }

            this.saveWishlist();
        }

        updateAllButtons() {
            document.querySelectorAll('.product-card-modern__wishlist').forEach(button => {
                const productId = button.dataset.productId;
                if (this.wishlist.includes(productId)) {
                    button.classList.add('is-active');
                }
            });
        }

        showNotification(message) {
            // Einfache Notification (kann später erweitert werden)
            const notification = document.createElement('div');
            notification.className = 'wishlist-notification';
            notification.textContent = message;
            notification.style.cssText = `
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #2d5016;
        color: white;
        padding: 12px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 10000;
        animation: slideInUp 0.3s ease;
      `;

            document.body.appendChild(notification);

            setTimeout(() => {
                notification.style.animation = 'slideOutDown 0.3s ease';
                setTimeout(() => notification.remove(), 300);
            }, 2000);
        }
    }

    // Quick Add to Cart Funktionalität
    class QuickAddManager {
        constructor() {
            this.init();
        }

        init() {
            document.addEventListener('click', (e) => {
                const addBtn = e.target.closest('.product-card-modern__add-to-cart');
                if (addBtn && !addBtn.disabled) {
                    e.preventDefault();
                    const variantId = addBtn.dataset.variantId;
                    this.addToCart(variantId, addBtn);
                }
            });
        }

        async addToCart(variantId, button) {
            const originalText = button.innerHTML;
            button.disabled = true;
            button.innerHTML = '<span>Wird hinzugefügt...</span>';

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                });

                if (response.ok) {
                    button.innerHTML = '<span>✓ Hinzugefügt!</span>';
                    button.style.background = '#059669';

                    // Update cart count
                    this.updateCartCount();

                    // Reset button after 2 seconds
                    setTimeout(() => {
                        button.innerHTML = originalText;
                        button.style.background = '';
                        button.disabled = false;
                    }, 2000);
                } else {
                    throw new Error('Failed to add to cart');
                }
            } catch (error) {
                console.error('Error adding to cart:', error);
                button.innerHTML = '<span>Fehler</span>';
                button.style.background = '#dc2626';

                setTimeout(() => {
                    button.innerHTML = originalText;
                    button.style.background = '';
                    button.disabled = false;
                }, 2000);
            }
        }

        async updateCartCount() {
            try {
                const response = await fetch('/cart.js');
                const cart = await response.json();

                // Update all cart count elements
                document.querySelectorAll('.cart-count').forEach(el => {
                    el.textContent = cart.item_count;
                    if (cart.item_count > 0) {
                        el.classList.remove('hidden-count');
                    }
                });
            } catch (error) {
                console.error('Error updating cart count:', error);
            }
        }
    }

    // Smooth Scroll für Scroll-Indicator
    document.addEventListener('click', (e) => {
        const scrollIndicator = e.target.closest('.hero-brand-modern__scroll-indicator');
        if (scrollIndicator) {
            e.preventDefault();
            const heroSection = scrollIndicator.closest('.hero-brand-modern');
            const nextSection = heroSection.nextElementSibling;

            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });

    // Sticky Header
    let lastScroll = 0;
    const header = document.querySelector('.site-header');

    if (header) {
        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset;

            if (currentScroll > 100) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }

            lastScroll = currentScroll;
        });
    }

    // CSS Animations
    const style = document.createElement('style');
    style.textContent = `
    @keyframes slideInUp {
      from {
        transform: translateY(100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
    
    @keyframes slideOutDown {
      from {
        transform: translateY(0);
        opacity: 1;
      }
      to {
        transform: translateY(100%);
        opacity: 0;
      }
    }
    
    .is-visible {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
    
    .site-header.is-scrolled {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      background: rgba(255, 255, 255, 0.98);
    }
  `;
    document.head.appendChild(style);

    // Initialize managers
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            new WishlistManager();
            new QuickAddManager();
        });
    } else {
        new WishlistManager();
        new QuickAddManager();
    }

})();
